/**
 * loginfos service
 */

import Resource from './resource'

export default new Resource('loginfos')



// WEBPACK FOOTER //
// ./src/libraries/services/loginfos.js